import { GET_APPLICATIONS_BY_COMPANY_ID_LIST, GET_APPLICATIONS_BY_COMPANY_ID_LIST_PAGINATION, GET_TOTAL_AUTHORIZED_CREDIT } from '../constants';
import { api } from './../index';

export function getTotalAuthorizedCredit(applicationList) {
    return function (dispatch) {
        dispatch({ type: GET_TOTAL_AUTHORIZED_CREDIT, payload: applicationList });
    }
}

export function getApplicationsByCompanyIdList() {
    // console.log(companyIdList)
    return function (dispatch) {
        api.get("/applications/company")
            .then(response => {
                dispatch({ type: GET_APPLICATIONS_BY_COMPANY_ID_LIST, payload: response.data });
            })
    }
}

export function getApplicationsByCompanyIdListPagination(queryParams) {
    const options = {
        validateStatus: status => status < 400,
        params: { queryParams }
    }
    console.log("~~~~Getting Applications with pag!")
    return function (dispatch) {
        api.get(`/applications/company/pagination`, options)
            .then(response => {
                console.log("Res actions: ", response)
                dispatch({ type: GET_APPLICATIONS_BY_COMPANY_ID_LIST_PAGINATION, payload: response.data });
            })
    }
}
